<template>
  <div class="page">
    <div class="flex-col">
      <div class="ab-header-home flex-col about_nav">
        <MainNav />
      </div>
    </div>
    <div class="about">
      <div class="about_banner">
        <!-- <a href=""> -->
        <img src="~@/assets/about/banner.jpg" alt="" />
        <!-- <i
            class="iconfont icon-bofang"
            data-aos="zoom-in"
            data-aos-delay="100"
          ></i> -->
        <!-- </a> -->
      </div>
      <div class="">
        <a-tabs @change="infoTabsChange" v-model="activeKey">
          <a-tab-pane key="intro" tab="公司介绍">
            <!-- 公司介绍 -->
            <div class="about_introduction clearfix">
              <div class="fl" data-aos="fade-rihgt" data-aos-delay="100">
                <!-- <img src="~@/assets/about/pic_5.jpg" alt="" /> -->
                <img src="~@/assets/about/公司介绍.jpg" alt="" />
              </div>
              <div class="fr" data-aos="fade-left" data-aos-delay="100">
                <div class="about_title">
                  公司介绍
                  <i></i>
                </div>
                <p>
                  上海牧客网络科技有限公司是一家技术创新型企业，专注于为外贸企业提供智能化营销解决方案，推动外贸行业的数字化转型和高效发展。公司旗下品牌——AB客，以其核心产品“外贸极客”在外贸B2B出口行业内建立了强大的市场地位，使全球企业在拓展国际市场的过程中保持卓越竞争力。
                </p>
                <p>
                  AB客秉持“技术创新赋能企业，简化全球贸易复杂性，促进普惠商业繁荣”的品牌理念，致力于利用先进技术为外贸企业提供更加高效、精准、便捷的解决方案。我们的品牌口号“智领未来，外贸超级营销员”充分体现了我们在智能营销领域的领先优势与远大愿景。
                </p>
                <p>
                  我们依托AGI（通用人工智能）、AIGC（人工智能生成内容）等前沿技术，结合大数据分析和AI底层技术，推出了外贸极客这一智能营销SaaS工具。该产品集成了营销管理、营销内容、推广引流、快速获客、客服管理、AI营销等功能模块，全面满足不同规模外贸企业的应用需求。
                </p>
                <p>
                  公司创始人拥有15年以上深耕国际市场营销和外贸网络营销的实战经验，我们还拥有很多非常优秀的研发人员和运营人。此外，我们非常专业可靠的服务团队，持续追踪市场动态和客户需求，确保我们的产品和服务始终处于行业前沿。
                </p>
                <p>
                  我们始终坚持“用户至上”的宗旨，以创新推动行业发展，为客户创造更多价值，成就全球市场中的杰出表现。
                </p>
              </div>
            </div>

            <div class="about_culture">
              <div class="about_title" data-aos="fade" data-aos-delay="100">
                公司介绍
                <i></i>
              </div>

              <ul class="clearfix">
                <li data-aos="fade" data-aos-delay="100">
                  <div>
                    <b>使命</b>
                    <span>让国际贸易变得轻松而简单</span>
                    <i> <img src="~@/assets/about/ico_1.png" alt="" /> </i>
                  </div>
                </li>
                <li data-aos="fade" data-aos-delay="200">
                  <div>
                    <b>愿景</b>
                    <span>外贸超级营销员</span>
                    <i> <img src="~@/assets/about/ico_2.png" alt="" /> </i>
                  </div>
                </li>
                <li data-aos="fade" data-aos-delay="300">
                  <div>
                    <b>价值观</b>
                    <span
                      >用户至上 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 行业赋能 <br />
                      拥抱变化 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 创新双赢</span
                    >
                    <i> <img src="~@/assets/about/ico_3.png" alt="" /> </i>
                  </div>
                </li>
              </ul>
            </div>

            <div class="about_course" v-if="false">
              <div class="warp">
                <div class="about_title" data-aos="fade">
                  发展历程
                  <i></i>
                </div>
              </div>

              <!-- 历程 -->
              <a-tabs
                defaultActiveKey="6"
                data-aos="fade-down"
                data-aos-delay="100"
              >
                <a-tab-pane key="1">
                  <template #tab>
                    <span>
                      <i> </i>
                      2015年
                    </span>
                  </template>
                  <div class="about_course_1 warp">
                    <b>2015年大事记</b>
                    <ul class="clearfix">
                      <li>
                        <div>
                          <i></i>
                          <span>
                            这是具有里程碑意义的一年，和每个怀揣着梦想的年轻人一样，创始人坚信未来的全球贸易模式将有无限的可能，便毅然决定走出阿里巴巴，成为了业内开拓者与探索者，提出“以数字化产品赋能产业生态，为出海企业提供整体解决方案“为核心理念，并吸引了更多的有着共同理想的有志年轻人加入。经过多年的深耕细作，由一个人变成了一支强有力的团队，客户的信任也在不断的递增，助力外贸数字化转型成为了每一位成员前行的动力和肩负的使命，这也为日后的AB客发展奠定了坚实的基础···
                          </span>
                        </div>
                      </li>
                      <!-- <li>
                      <div>
                        <i></i>
                        <span>
                          4月-正式推出以融合渠道获客、品牌营销、商机挖掘、数据决策等全链路技术性与战略性为支撑的询盘速递、询盘服务、品牌营销三大服务体系产品，旨在为外贸企业打造最具价值的出海产品
                        </span>
                      </div>
                    </li>
                    <li>
                      <div>
                        <i></i>
                        <span>
                          4月-正式推出以融合渠道获客、品牌营销、商机挖掘、数据决策等全链路技术性与战略性为支撑的询盘速递、询盘服务、品牌营销三大服务体系产品，旨在为外贸企业打造最具价值的出海产品
                        </span>
                      </div>
                    </li>
                    <li>
                      <div>
                        <i></i>
                        <span>
                          4月-正式推出以融合渠道获客、品牌营销、商机挖掘、数据决策等全链路技术性与战略性为支撑的询盘速递、询盘服务、品牌营销三大服务体系产品，旨在为外贸企业打造最具价值的出海产品
                        </span>
                      </div>
                    </li>
                    <li>
                      <div>
                        <i></i>
                        <span>
                          4月-正式推出以融合渠道获客、品牌营销、商机挖掘、数据决策等全链路技术性与战略性为支撑的询盘速递、询盘服务、品牌营销三大服务体系产品，旨在为外贸企业打造最具价值的出海产品
                        </span>
                      </div>
                    </li>
                    <li>
                      <div>
                        <i></i>
                        <span>
                          4月-正式推出以融合渠道获客、品牌营销、商机挖掘、数据决策等全链路技术性与战略性为支撑的询盘速递、询盘服务、品牌营销三大服务体系产品，旨在为外贸企业打造最具价值的出海产品
                        </span>
                      </div>
                    </li> -->
                    </ul>
                  </div>
                </a-tab-pane>
                <a-tab-pane key="2">
                  <template #tab>
                    <span>
                      <i></i>
                      2018年
                    </span>
                  </template>
                  <div class="about_course_1 warp">
                    <b>2018年大事记</b>
                    <ul class="clearfix">
                      <li>
                        <div>
                          <i></i>
                          <span> 5月-运营团队及营销团队顺利组建完成 </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <i></i>
                          <span>
                            8月-上海牧客网络科技有限公司正式成立，由B2B外贸行业资深运营人携手阿里、腾讯跨境电商互联网精英，写下AB客智能营销系统的第一行代码
                          </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <i></i>
                          <span>
                            11月-CRM客户管理系统正式上线，赋能外贸营销，助力外贸企业高效管理运营
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </a-tab-pane>
                <a-tab-pane key="3">
                  <template #tab>
                    <span>
                      <i></i>
                      2019年
                    </span>
                  </template>
                  <div class="about_course_1 warp">
                    <b>2019年大事记</b>
                    <ul class="clearfix">
                      <li>
                        <div>
                          <i></i>
                          <span>
                            9月-分别在北京、无锡、郑州等城市设立分支服务机构，业务范围辐射全国
                          </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <i></i>
                          <span>
                            10月-推出资费低、稳定性高的全球电话业务，同时公测询盘业务产品
                          </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <i></i>
                          <span>
                            11月-全面整合外贸营销服务体系，致力于为外贸企业提供全周期解决方案，拓展建站营销、跨境通讯、海关数据、CRM商机管理、服务咨询等业务模式
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </a-tab-pane>
                <a-tab-pane key="4">
                  <template #tab>
                    <span>
                      <i></i>
                      2020年
                    </span>
                  </template>
                  <div class="about_course_1 warp">
                    <b>2020年大事记</b>
                    <ul class="clearfix">
                      <li>
                        <div>
                          <i></i>
                          <span>
                            5月-基于云计算和大数据技术，为外贸企业提供一站式的主动式客户开发，打造贸易情报分析、SNS营销、SAAS模式客户管理于一体的外贸工作平台
                          </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <i></i>
                          <span>
                            7月-重磅推出询盘速递产品，同期客户注册量突破3w+
                          </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <i></i>
                          <span> 11月-获批成为中国服务贸易协会会员单位 </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </a-tab-pane>
                <a-tab-pane key="5">
                  <template #tab>
                    <span>
                      <i></i>
                      2021年
                    </span>
                  </template>
                  <div class="about_course_1 warp">
                    <b>2021年大事记</b>
                    <ul class="clearfix">
                      <li>
                        <div>
                          <i></i>
                          <span>
                            5月-荣获上海市人工智能技术协会第一届理事会单位
                          </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <i></i>
                          <span>
                            8月-基于获客营销及AI数据分析能力，询盘速递产品优化升级
                          </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <i></i>
                          <span>
                            9月-正式启动XST新算法，布局海外数据运营中心，对贸易数据及企业透视全方位升级
                          </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <i></i>
                          <span>
                            12月-推出营销站群服务，高效提升Google海外站点营销，深耕行业细分解决方案
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </a-tab-pane>
                <a-tab-pane key="6">
                  <template #tab>
                    <span>
                      <i></i>
                      2022年
                    </span>
                  </template>
                  <div class="about_course_1 warp">
                    <b>2022年大事记</b>
                    <ul class="clearfix">
                      <li>
                        <div>
                          <i></i>
                          <span>
                            2月-以贸易数据分析及提供数字化资产服务的全球5大数据服务中心正式投入运营，助力企业科学决策
                          </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <i></i>
                          <span>
                            3月-业绩实现突破，其本地专业服务团队覆盖华东、华北及华南地区200+主要外贸重地，为贸易企业提供无差异化信息服务
                          </span>
                        </div>
                      </li>
                      <li>
                        <div>
                          <i></i>
                          <span>
                            5月-询盘速递、询盘服务、品牌营销三大服务体系产品全面升级，旨在为外贸企业提供一站式出海全流程解决方案
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </a-tab-pane>
              </a-tabs>
              <!-- 历程 -->
            </div>
            <!-- 荣誉资质 -->
            <!-- <div class="about_honor">
            <div class="about_title" data-aos="fade">
              荣誉资质
              <i></i>
            </div>
            <div data-aos="fade-down" data-aos-delay="100"><AboutSwiper /></div>
          </div> -->
            <!-- 荣誉资质 -->
            <!-- 公司介绍 -->
          </a-tab-pane>
          <!-- <a-tab-pane key="2" tab="企业新闻" force-render>
          <div class="about_news">
            <ul>
              <li>
                <a href="" class="clearfix">
                  <div class="fl">
                    <span>
                      <i class="fontsize26"
                        >拜登：美国对中国商品加征的关税继续</i
                      >
                      <b></b>
                      <p class="fontsize18">
                        在今天商务部举行的例行新闻发布会上，有媒体问，美国时间的周三，拜登在发布会上表示他还没有准备好取消他前任加征的关税，请问商务部有何评论？对此，商务部新闻发言人束珏婷表示，中方始终认为，取消加征关税有利于中国，有利于美国，有利于世界。特别是在当前通胀形势下，取消加征关税符合中美两国消费者和生产者的根本利益，有利于世界经济恢复。
                      </p>
                      <label class="fontsize18"
                        ><em
                          >AB客
                          <dd></dd
                        ></em>
                        <em
                          >经济
                          <dd></dd
                        ></em>
                        <em
                          >美国
                          <dd></dd></em
                      ></label>
                      <strong class="fontsize18">2022-06-14</strong>
                    </span>
                  </div>
                  <div class="fr">
                    <a href=""><img src="~@/assets/about/pic_6.jpg" alt=""/></a>
                  </div>
                </a>
              </li>
              <li>
                <a href="" class="clearfix">
                  <div class="fl">
                    <span>
                      <i class="fontsize26"
                        >拜登：美国对中国商品加征的关税继续</i
                      >
                      <b></b>
                      <p class="fontsize18">
                        在今天商务部举行的例行新闻发布会上，有媒体问，美国时间的周三，拜登在发布会上表示他还没有准备好取消他前任加征的关税，请问商务部有何评论？对此，商务部新闻发言人束珏婷表示，中方始终认为，取消加征关税有利于中国，有利于美国，有利于世界。特别是在当前通胀形势下，取消加征关税符合中美两国消费者和生产者的根本利益，有利于世界经济恢复。
                      </p>
                      <label class="fontsize18"
                        ><em
                          >AB客
                          <dd></dd
                        ></em>
                        <em
                          >经济
                          <dd></dd
                        ></em>
                        <em
                          >美国
                          <dd></dd></em
                      ></label>
                      <strong class="fontsize18">2022-06-14</strong>
                    </span>
                  </div>
                  <div class="fr">
                    <a href=""><img src="~@/assets/about/pic_6.jpg" alt=""/></a>
                  </div>
                </a>
              </li>
              <li>
                <a href="" class="clearfix">
                  <div class="fl">
                    <span>
                      <i class="fontsize26"
                        >拜登：美国对中国商品加征的关税继续</i
                      >
                      <b></b>
                      <p class="fontsize18">
                        在今天商务部举行的例行新闻发布会上，有媒体问，美国时间的周三，拜登在发布会上表示他还没有准备好取消他前任加征的关税，请问商务部有何评论？对此，商务部新闻发言人束珏婷表示，中方始终认为，取消加征关税有利于中国，有利于美国，有利于世界。特别是在当前通胀形势下，取消加征关税符合中美两国消费者和生产者的根本利益，有利于世界经济恢复。
                      </p>
                      <label class="fontsize18"
                        ><em
                          >AB客
                          <dd></dd
                        ></em>
                        <em
                          >经济
                          <dd></dd
                        ></em>
                        <em
                          >美国
                          <dd></dd></em
                      ></label>
                      <strong class="fontsize18">2022-06-14</strong>
                    </span>
                  </div>
                  <div class="fr">
                    <a href=""><img src="~@/assets/about/pic_6.jpg" alt=""/></a>
                  </div>
                </a>
              </li>
            </ul>
            <span class="about_news_btn">
              <a class="btn_blue">查看更多</a>
            </span>
          </div>
        </a-tab-pane> -->
          <a-tab-pane key="contact" tab="联系我们">
            <!-- 联系我们 -->
            <div class="warp">
              <div class="about_lxwm">
                <ul class="clearfix">
                  <li>
                    <div>
                      <span>
                        <em> <img src="~@/assets/about/ico_4.png" alt=""/></em>
                        <b>服务热线<i>400-076-6558</i></b>
                      </span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <span>
                        <em> <img src="~@/assets/about/ico_5.png" alt=""/></em>
                        <b>售后热线<i>18739929880</i></b>
                      </span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <span>
                        <em> <img src="~@/assets/about/ico_6.png" alt=""/></em>
                        <b
                          >市场合作<i
                            ><a href="mailto:marketing@cnabke.com"
                              >marketing@cnabke.com</a
                            ></i
                          ></b
                        >
                      </span>
                    </div>
                  </li>
                  <li>
                    <div>
                      <span>
                        <em> <img src="~@/assets/about/ico_7.png" alt=""/></em>
                        <b
                          >服务建议<i
                            ><a href="mailto:services@cnabke.com"
                              >services@cnabke.com</a
                            ></i
                          ></b
                        >
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 地址 -->
            <div class="about_lxwm_1">
              <a-tabs
                type="card"
                v-model="activeAddKey"
                @change="addressTabsChange"
              >
                <a-tab-pane key="container1">
                  <span slot="tab">
                    <img src="~@/assets/about/ico_8.png" alt="" />
                    <em>
                      <b>上海（总部）</b>
                      <i>上海市嘉定区运通星财富广场B座20层</i>
                    </em>
                  </span>
                  <div class="about_lxwm_r">
                    <!-- <a
                      href="https://map.baidu.com/poi/%E8%BF%90%E9%80%9A%E6%98%9F%E8%B4%A2%E5%AF%8C%E5%B9%BF%E5%9C%BA-B%E5%BA%A7/@13506254.32232592,3648265.628920894,15.72z?uid=cebe7317a7d44738f33cbae9&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl"
                      target="_blank"
                      ><img src="~@/assets/about/pic_7.jpg" alt=""
                    /></a> -->
                    <!-- <div id="container1" class="container"></div> -->
                    <div class="container">
                      <ab-loading :loading="loading"></ab-loading>
                      <div
                        id="container1"
                        style="overflow: hidden; width: 100%; height: 100%; margin: 0"
                      ></div>
                    </div>
                  </div>
                </a-tab-pane>
                <a-tab-pane key="container2">
                  <span slot="tab">
                    <img src="~@/assets/about/ico_8.png" alt="" />
                    <em>
                      <b>郑州分公司</b>
                      <i>郑州市高新区莲花街与健杨路联东u谷20号楼10楼</i>
                    </em>
                  </span>
                  <div class="about_lxwm_r">
                    <div class="container">
                      <ab-loading :loading="loading"></ab-loading>
                      <div
                        id="container2"
                        style="overflow: hidden; width: 100%; height: 100%; margin: 0"
                      ></div>
                    </div>
                    <!-- <a
                      href="https://map.baidu.com/poi/%E9%83%91%E5%B7%9E%E5%A8%81%E7%A7%91%E5%A7%86%E7%A7%91%E6%8A%80%E5%85%AC%E5%8F%B8-A%E5%BA%A7/@12642676.349999996,4116250.697464838,16.14z?uid=8dd3766a1cc303dd2b3a9f3d&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl"
                      target="_blank"
                    >
                      <img src="~@/assets/about/pic_8.jpg" alt=""
                    /></a> -->
                  </div>
                </a-tab-pane>
              </a-tabs>
              <div class="warp">
                <div class="about_lxwm_wx">
                  <dl class="clearfix">
                    <dd>
                      <img src="~@/assets/images/wx.jpg" />
                      <div>官方公众号</div>
                    </dd>
                    <dd>
                      <img src="~@/assets/images/wb.jpg" />
                      <div>外贸精英社</div>
                    </dd>
                  </dl>
                </div>
              </div>

              <!-- 联系我们 -->
            </div>
            <!-- 地址 -->
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import loadJs from "@/utils/loadJs";
// import BaiduMap from "@/utils/bmp";
import $ from "jquery";
import AbLoading from "@/components/AbLoading.vue";
import MainNav from "@/components/MainNav.vue";
import AboutSwiper from "./components/AboutSwiper.vue";
import metaInfo from "@/metaInfo";

import { BMPGL } from "@/bmpgl.js";
export default {
  metaInfo: metaInfo["About"],
  components: {
    MainNav,
    AboutSwiper,
    AbLoading,
  },
  data() {
    return {
      activeKey: "intro",
      activeAddKey: "container1",
      loading: false,
    };
  },
  // async mounted() {
  //   await loadJs(
  //     "http://api.map.baidu.com/api?type=webgl&v=2.0&ak=vc9AIMh1xXFr9PCf5sNxCMDCu6HPLCba"
  //   );
  // },
  methods: {
    infoTabsChange(key) {
      console.log(key);
      this.activeKey = key;
      if (key === "contact") {
        this.addressMap("container1");
      }
    },

    addressTabsChange(key) {
      console.log(key);
      this.activeAddKey = key;
      // if (key === "contact") {
      this.addressMap(key);
      // }
    },
    addressMap(conainerKey) {
      this.loading = true;
      BMPGL("vc9AIMh1xXFr9PCf5sNxCMDCu6HPLCba")
        .then((BMapGL) => {
          if (conainerKey === "container2") {
            setTimeout(() => {
              // 百度地图API功能
              let map = new BMapGL.Map("container2");
              let point = new BMapGL.Point(113.569569, 34.830301);
              map.centerAndZoom(point, 15);
              map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
              let marker = new BMapGL.Marker(point); // 创建标注
              map.addOverlay(marker); // 将标注添加到地图中
              let opts = {
                width: 320, // 信息窗口宽度
                height: 60, // 信息窗口高度
                // title: "上海牧客科技网络有限公司-郑州分公司", // 信息窗口标题
                title:
                  '<div class="bmp-title" > <a href="https://map.baidu.com/poi/%E9%83%91%E5%B7%9E%E5%A8%81%E7%A7%91%E5%A7%86%E7%A7%91%E6%8A%80%E5%85%AC%E5%8F%B8-A%E5%BA%A7/@12642676.349999996,4116250.697464838,16.14z?uid=8dd3766a1cc303dd2b3a9f3d&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl" target="_blank">上海牧客科技网络有限公司-郑州分公司</a> </div>',
                // message:"这里是故宫"
              };
              let infoWindow = new BMapGL.InfoWindow(
                '<div class="bmp-content" > 地址：郑州市高新区莲花街与健杨路联东u谷20号楼10楼</div>' +
                  '<div class="bmp-content" > 热线：400-076-6558 </div>',
                opts
              );
              map.openInfoWindow(infoWindow, point);
              // 创建信息窗口对象
              // new BaiduMap({
              //   id: "container2",
              //   title: {
              //     text: "上海牧客科技网络有限公司-郑州分公司",
              //     className: "bmp-title",
              //   },
              //   content: {
              //     className: "bmp-content",
              //     text: [
              //       "地址：郑州市高新区莲花街55号威科姆大厦A座10楼",
              //       "热线：400-076-6558",
              //     ],
              //   },
              //   point: {
              //     lng: 113.569569,
              //     lat: 34.830301,
              //   },
              //   level: 15,
              //   zoom: true,
              //   type: ["地图", "卫星", "三维"],
              //   width: 320,
              //   height: 70,
              // });
              this.loading = false;
            }, 2000);
          } else {
            setTimeout(() => {
              let map = new BMapGL.Map("container1");
              let point = new BMapGL.Point(121.33101, 31.296348);
              map.centerAndZoom(point, 15);

              let marker = new BMapGL.Marker(point); // 创建标注
              map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
              map.addOverlay(marker); // 将标注添加到地图中
              let opts = {
                width: 320, // 信息窗口宽度
                height: 60, // 信息窗口高度
                title:
                  '<div class="bmp-title" > <a href="https://map.baidu.com/poi/%E8%BF%90%E9%80%9A%E6%98%9F%E8%B4%A2%E5%AF%8C%E5%B9%BF%E5%9C%BA-B%E5%BA%A7/@13506254.32232592,3648265.628920894,15.72z?uid=cebe7317a7d44738f33cbae9&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl" target="_blank">上海牧客科技网络有限公司-总部</a> </div>',
                // title: '<div class="bmp-title" > 上海牧客科技网络有限公司-总部 </div>',
                //"上海牧客科技网络有限公司-总部", // 信息窗口标题
                // message:"这里是故宫"
              };
              let infoWindow = new BMapGL.InfoWindow(
                '<div class="bmp-content" > 地址：上海市嘉定区运通星财富广场B座20层 </div>' +
                  '<div class="bmp-content" > 热线：400-076-6558 </div>',
                opts
              );
              map.openInfoWindow(infoWindow, point);
              // new BaiduMap({
              //   id: "container1",
              //   title: {
              //     text: "上海牧客科技网络有限公司-总部",
              //     className: "bmp-title",
              //   },
              //   content: {
              //     className: "bmp-content",
              //     text: ["地址：上海市嘉定区运通星财富广场B座20层", "热线：400-076-6558"],
              //   },
              //   point: {
              //     lng: 121.33101,
              //     lat: 31.296348,
              //   },
              //   level: 15,
              //   zoom: true,
              //   type: ["地图", "卫星", "三维"],
              //   width: 320,
              //   height: 70,
              // });
              this.loading = false;
            }, 2000);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="sass">
.about_nav .nav .nav-bar li {
    height: 1.6rem;
}
.index_eight{
  display: none
}
.about{
  .about_lxwm_wx{
    padding-left: 86px;
    bottom: 127px;
    position: absolute;

    dd{
      float: left;
      text-align:center;
      font-size:18px;
      line-height:25px;
      color:#333;
      margin:0px 15px;
      img{
        width:160px;
      }
    }
  }
  .container{
    // border: 2px solid #000;
    width: 810px;
    height: 580px;
    // .des {
		// 		float: right;
		// 		width: 48%;
		// 		height: 100%;
		// 		border: 1px dashed #000;
		// 		box-sizing: border-box;
		// 	}

		// 	.info {
		// 		margin-top: 20px;
		// 		padding-left: 20px;
		// 		color: #cc5522;
		// 		font-size: 20px;
		// 		margin-bottom: 40px;
		// 		text-align: center;
		// 	}

		// 	pre {
		// 		font-size: 14px;
		// 	}
    .bmp-title {
      margin-top: 6px;
      a{
        font-size: 14px;
        font-weight: bold;
        color: #cc5522;
      }
    }

    .bmp-content {
      font-size: 13px;
      color: #333;
      // margin-top: 6px;
    }
  }
  .about_lxwm_1{
      height:680px;
      position: relative;
      .ant-tabs-content{
        margin-top: -81px;
      }
    .about_lxwm_r{

      float: right;
      width: 50%;
      position: relative;
      z-index: 22;
      img{
        &:hover{
              box-shadow: 0.31333rem 0.31333rem 0.53333rem 0 rgb(55 99 170 / 90%);
        }
        // width: 100%
      }
    }
    .ant-tabs-nav{
      span{
        em{
          margin-left:90px;
              display: inline-block;
          i{
            color:rgba(51,51,51,.8);
            font-size:18px;
            font-weight:400;
             font-family: 'Alibaba-PuHuiTi-R';
          }
          b{
            font-weight: 400;
            font-size: 26px;
            display: block;
            color:#333;
                margin-bottom: -4px;
                    margin-top: 33px;
          }
        }

      }
      .ant-tabs-ink-bar{
       display:none !important;
     }
      width:49%;

      .ant-tabs-tab-active.ant-tabs-tab{
        border: 3px solid #198BFF;transition: all .3s;
          img{
          display:block;
        }

      }
      .ant-tabs-tab{
          display: block;
        margin-right: 9px;
        width: 85%;
        transform: translateZ(0);
        transition: all .3s;
        height: 140px;
        border-radius: 8px;
        border: 3px solid #fff;
        background:#fff;
        z-index: 11;
        span{
          img{
            display:none;
                position: absolute;
            top: 51px;
            left: 27px;
            width:34px;
          }
        }
    }
    }
    .ant-tabs-bar{
      margin-top:0px;
      border:none;
    }
  }
  .about_lxwm{
    ul{
      margin:50px -9px 70px -9px;
      li{
        float: left;
        width:50%;
        padding:9px;
        div{
          display: flex;
          flex-wrap: wrap;
          align-content: center;
          height: 330px;
          background: #F9FBFF;
          border-radius: 8px;
          border: 1px solid #DCE6FF;
          span{
          display: flex;
                width: 100%;
                b{
                  font-size:40px;
                  margin-top: -14px;
                  font-weight:normal;
                     display: block;color: #333;
                     i{
                       font-family: 'Alibaba-PuHuiTi-R';
                      display: block;
                      font-size:30px;
                      color: #2B68FF;
                      margin-top:10px;
                      a{
                        color: #2B68FF;
                      }
                      a:hover{
                            text-decoration: underline;
                      }
                     }
                }
          }
          img{
          margin-left:158px;
          margin-right:30px;
            width:100px;
          }

        }
      }
    }

  }
  .about_news_btn{
    display: block;
    margin:60px auto 80px;
        text-align: center;
    a{
      width: 200px;
      height: 64px;
      line-height:64px;
      border-radius: 6px;
      box-shadow:none;
      font-size:20px;
    }

  }
  .about_news li a:hover div img{
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .about_news li:nth-child(even) .fl{
      float: right;
      span{
        padding-left:110px;
      }
  }
  .about_news li:hover{
i{
   color:#2B68FF;
  }
  p{
    color:#000
  }
  }
  .about_news div span label  em:last-child dd{
    display: none
  }
.about_news{
  div{
    width:50%;
    overflow: hidden;
    span{
    display: block;
    padding:85px 100px 80px 255px;
    label{
      font-size: 18px;
      font-family: 'Alibaba-PuHuiTi-R';
      font-weight: normal;
      color: #2B68FF;
      line-height: 25px;
      dd{
        display: inline-block;width: 1px;
        margin:0px 10px 0px 15px;
        height: 12px;
        background: #333646;
        opacity: 0.5;
      }
    }
    strong{
    color: #333646;
      display: block;font-family: 'Alibaba-PuHuiTi-R';
      margin-top:20px;
      font-weight:400
    }
    p{
      color:#666;
      line-height:30px;
      font-family: 'Alibaba-PuHuiTi-R';
      height:150px;
      overflow: hidden;
      margin-bottom:30px
    }
    b{
      width: 118px;
      height: 6px;
      background: #FF6531;display: block;
      margin:22px 0px 15px;
    }
    }
    i{
      display: block;
      font-size: 26px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color:#333;

    }
    img{
      width:100%;
      -webkit-transition: -webkit-transform 1.2s;
      transition: transform 1.2s;
    }
  }
}
.about_honor{

  .about_title{
    margin-top:50px;
    text-align: center;
    i{
      margin:30px auto 55px;
    }
  }
}
  .about_course{
    background:url(~@/assets/about/bg.jpg) top center;
    height:900px;
    .about_title{
      padding-top:60px;
    }
    .about_course_1{
      ul{
        margin: 0px -15px;
        li{
          width:25%;
          padding:15px;
          float: left;
          div{
            background: #FFFFFF;
            border-radius: 6px;
            border: 1px solid #F0F0F0;
            padding:20px 25px;

            i{

              width: 8px;
              height: 8px;border-radius: 50%;
              background: #2B68FF;
              float: left;
                  display: block;
              margin-right: 13px;
              margin-top: 7px;

            }
            span{
              font-size: 16px;
              overflow: hidden;
              min-height:130px;
              font-family: 'Alibaba-PuHuiTi-R';
              line-height: 26px;
              display: block;

            }
          }
        }
      }
      b{
        font-size: 26px;
        color: #333646;
        line-height: 35px;
        display: block;
        padding:80px 0px 45px  0px;
      }
    }
    .ant-tabs-nav {
      width:100%;
      .ant-tabs-tab.ant-tabs-tab-active{
        i{
          height: 40px;
          width: 40px !important;
          border-radius: 50%;
          border: 8px solid #fff;
          box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 20%);
          bottom: -20px;
          position: absolute;
          background:#2b68ff;
          left: 50%;
          margin-left: -20px;
          transition: all .3s;
        }
      }
      .ant-tabs-tab{
          color:#666;
          padding:0px;
          padding-bottom:30px;
          width: 14.28%;
          text-align: center;
          margin-right:0px;
          i{
            height:30px;
            width:30px;
            border-radius: 50%;
            display: inline-block;background:#abafc5;
            border:6px solid #fff;
            box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 20%);
                position: absolute;
            left: 50%;
            margin-left: -15px;
            bottom: -15px;    transform: translateZ(0);
            transition: all .3s;
          }

      }
      .ant-tabs-tab-active{
      font-size:30px;
      color:#2B68FF
    }
    }
    .ant-tabs-nav-scroll{
    width: 1620px;
    margin: 0px auto;
    }
    .ant-tabs-ink-bar{

    opacity: 0

    }
    .ant-tabs-bar{
      width:auto;
      border-bottom:4px solid #dde6f3;
    }

  }
  .about_culture{
    ul{
      margin: 0px -18px;
      margin-bottom:75px;
    }
    li{
      float: left;
      width:33.3333%;
      padding:0px 18px;
      &:hover {
        div{
        background: #f6fbff;
        }

        }
      div{
        background:#fff;
        box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.2000);
        border-radius: 8px;
        border: 1px solid #C7E8FF;
        height:240px;
        position: relative;

        i{
          right:49px;
          position: absolute;
          top:66px;
          img{
            width:110px;
          }
        }
        span{
          font-size: 20px;
          color: #333646;
          line-height: 34px;
          display:block;
          padding-left:62px;
        }
        b{
          font-size: 40px;
          padding:52px 0px 30px 62px;
            display:block;
          color: #333646;
          line-height: 55px;
        }
      }
    }
  }
   .about_title{
      padding-top: 30px;
      font-size: 40px;
      color: #333646;
      line-height: 55px;
      i{
        width: 100px;
        height: 4px;
        display: block;
        margin-top: 30px;
        margin-bottom:40px;
        background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
      }
    }
  .about_introduction{
    padding:50px 0px;
    .fr{
      p{
        color: rgba(51,51,51,0.8);
        line-height: 30px;
        font-size: 18px;
        font-family: 'Alibaba-PuHuiTi-R';
      }
      width:47%;

    }
    .fl{
      width:50%;
      img{
        width: 800px;
        height:600px;
      }
    }
  }
  .ant-tabs-nav-scroll,.ant-tabs-nav-wrap,.ant-tabs-nav-container{
    overflow: inherit
  }
  .ant-tabs-bar,.about_introduction,.about_culture {
    width:1620px;
    margin:0px auto;

  }
  .ant-tabs-bar{
    border-bottom: 4px solid #ececec;
    padding-top:30px;
  }

  .ant-tabs-nav .ant-tabs-tab{
    font-size:20px;
      line-height: 40px;
  }
  .ant-tabs-nav .ant-tabs-tab-active {
    color: #2B68FF !important
  }
  .ant-tabs-ink-bar{
    height:4px;
    background:#1d84fd !important;
    bottom: -2px;
  }
   .about_banner{
    position: relative;
    a:hover i{
    -webkit-transform: translate(0%,0%) scale(1.2);
    -ms-transform: translate(0%,0%) scale(1.2);
    transform: translate(0%,0%) scale(1.2);
    }
    img{
      width:100%;
      height:654px;
    }
    i{
      position: absolute;
      width: 140px;
      height: 140px;
      background: rgba(255,255,255,0.7);
      display:inline-block;
      text-align:center;
      border-radius: 50%;
      font-size:50px;
      margin-left:-70px;
      left:50%;
      top:259px;
      color:#333646;
      text-indent: 14px;
      line-height: 140px;
      -webkit-transition: -webkit-transform .25s;
      transition: -webkit-transform .25s;
      -o-transition: transform .25s;
      transition: transform .25s;
      transition: transform .25s,-webkit-transform .25s;
      &:hover{
        background:#fff;
        color:#198BFF
      }
    }
  }
}


.about_nav .mainnav{
  .ant-affix .nav .nav-bar ul{
    margin-left:-6px;
    margin-top:20px;
  }
  // height:80px;
  .nav .nav-bar ul{
    margin-left:20px;
    margin-top:10px
  }
  .nav .nav-right-btn{
    margin-top:20px
  }
  .nav .nav-logo{
    width: 50px;
    margin-top: 18px;
  }
}
</style>
